module.exports = __webpack_public_path__ + "static/media/albertkuiper.342adcb6.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/albertkuiper.webp
// module id = 240
// module chunks = 0